import {isNullOrUndefined} from "./is-null-or-undefined";

export function isEmpty<T>(val: T | null | undefined): boolean {
  return isNullOrUndefined(val)
      || ((typeof val === "string" || val instanceof Array) && val.length === 0)
      || (val instanceof Object && Object.keys(val).length === 0)
  ;
}
